import VeeValidate from 'vee-validate'

import en from 'vee-validate/dist/locale/en'
import nl from 'vee-validate/dist/locale/nl'
import fr from 'vee-validate/dist/locale/fr'
import de from 'vee-validate/dist/locale/de'
import es from 'vee-validate/dist/locale/es'

VeeValidate.Validator.localize(en)
VeeValidate.Validator.localize(fr)
VeeValidate.Validator.localize(de)
VeeValidate.Validator.localize(es)
VeeValidate.Validator.localize(nl)

var alphaDashSpace = {
  en: /^[0-9A-Z_-\s]*$/i,
  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ_-\s]*$/i,
  da: /^[0-9A-ZÆØÅ_-\s]*$/i,
  de: /^[0-9A-ZÄÖÜß_-\s]*$/i,
  es: /^[0-9A-ZÁÉÍÑÓÚÜ_-\s]*$/i,
  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ_-\s]*$/i,
  nl: /^[0-9A-ZÉËÏÓÖÜ_-\s]*$/i,
  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ_-\s]*$/i,
  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ_-\s]*$/i,
  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-\s]*$/i,
  ru: /^[0-9А-ЯЁ_-\s]*$/i,
  sr: /^[0-9A-ZČĆŽŠĐ_-\s]*$/i,
  tr: /^[0-9A-ZÇĞİıÖŞÜ_-\s]*$/i,
  uk: /^[0-9А-ЩЬЮЯЄIЇҐ_-\s]*$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ_-\s]*$/
}

VeeValidate.Validator.extend('alpha_dash_spaces', {
  messages: {
    en: (field, args) => {
      return 'The ' + field + ' may contain alpha-numeric characters as well as dashes, underscores and spaces.'
    },
    nl: (field, args) => {
      return field + ' mag alleen letters, nummers, strepen en spaties bevatten.'
    },
    fr: (field, args) => {
      return field + ' ne peut contenir que des caractères alpha-numériques, tirets, soulignés ou des espaces.'
    },
    de: (field, args) => {
      return field + ' darf alphanumerische Zeichen sowie Striche, Unterstriche und Leerzeichen enthalten.'
    },
    es: (field, args) => {
      return 'El campo ' + field + ' solo debe contener letras, números, guiones y espacios.'
    }
  },
  validate (value, ref) {
    if (ref === void 0) ref = [null]
    var locale = ref[0]

    // Match at least one locale.
    if (!locale) {
      return Object.keys(alphaDashSpace).some(function (loc) { return alphaDashSpace[loc].test(value) })
    }

    return (alphaDashSpace[locale] || alphaDashSpace.en).test(value)
  }
})

export default VeeValidate



// WEBPACK FOOTER //
// ./src/validation/index.js